import { render, staticRenderFns } from "./EmployeeBoardCard.vue?vue&type=template&id=3c7b8f60&scoped=true&"
import script from "./EmployeeBoardCard.vue?vue&type=script&lang=js&"
export * from "./EmployeeBoardCard.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeBoardCard.vue?vue&type=style&index=0&id=3c7b8f60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7b8f60",
  null
  
)

export default component.exports